import { UserEssentials } from 'Types/User.types';
import { UsersMap } from 'hooks';
import { TreeSelectValue } from 'Components/Primitives';
import { nonNullable } from 'Utils/functional';

export const getSelectedUsers = (
  selectedIds: TreeSelectValue,
  usersMap: UsersMap
): UserEssentials | UserEssentials[] | null =>
  selectedIds
    ? typeof selectedIds === 'number'
      ? usersMap.get(selectedIds) || null
      : (selectedIds as number[]).map((id) => usersMap.get(id)).filter(nonNullable)
    : null;
